import React from 'react';
import Isvg from 'react-inlinesvg';
import PropTypes from 'prop-types';

import { bem } from 'helpers/class-name';
import Message from 'components/Message';
import Confirm from 'components/Confirm';
import { ICONS } from 'constants/icons';
import { messages } from '../Services.messages';

const { element } = bem('service-form');

function NoEquipmentOrPractitionerModal({ onConfirm, onRequestClose }) {
  return (
    <Confirm
      onConfirm={onConfirm}
      onRequestClose={onRequestClose}
      size="medium"
      title={
        <header className={element('modal-header')}>
          <Isvg src={ICONS.infoYellow} />
          <Message className="ml-small" message={messages.noEquipmentOrPractitionerModal.title} />
        </header>
      }
      cancelNode={<Message message={messages.noEquipmentOrPractitionerModal.stayOnPage} />}
      acceptNode={
        <Message
          data-cypress="service-modal-accept-button"
          message={messages.noEquipmentOrPractitionerModal.saveAndLeave}
        />
      }
      isOpen>
      <Message message={messages.noEquipmentOrPractitionerModal.description} />
    </Confirm>
  );
}

NoEquipmentOrPractitionerModal.propTypes = {
  onConfirm: PropTypes.func,
  onRequestClose: PropTypes.func,
};

export default NoEquipmentOrPractitionerModal;
